import { createFileRoute } from "@tanstack/react-router";

import NewGameSessionPage from "~/pages/gameSession/NewGameSessionPage.tsx";

export const Route = createFileRoute("/_auth/game-session/")({
    component: NewGameSessionPage,
});
